import React from "react"

export const ReferenceGuideIcon = ({ width = 24, height = 24, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M11.1789 2.18894C11.6324 1.93702 12.3676 1.93702 12.8211 2.18894L20.6599 6.54386C21.1134 6.79578 21.1134 7.20422 20.6599 7.45614L12.8211 11.8111C12.3676 12.063 11.6324 12.063 11.1789 11.8111L3.34009 7.45614C2.88664 7.20422 2.88664 6.79578 3.34009 6.54386L11.1789 2.18894Z" />
      <path d="M11.1789 7.18894C11.6324 6.93702 12.3676 6.93702 12.8211 7.18894L20.6599 11.5439C21.1134 11.7958 21.1134 12.2042 20.6599 12.4561L12.8211 16.8111C12.3676 17.063 11.6324 17.063 11.1789 16.8111L3.34009 12.4561C2.88664 12.2042 2.88664 11.7958 3.34009 11.5439L11.1789 7.18894Z" />
      <path d="M11.1789 12.1889C11.6324 11.937 12.3676 11.937 12.8211 12.1889L20.6599 16.5439C21.1134 16.7958 21.1134 17.2042 20.6599 17.4561L12.8211 21.8111C12.3676 22.063 11.6324 22.063 11.1789 21.8111L3.34009 17.4561C2.88664 17.2042 2.88664 16.7958 3.34009 16.5439L11.1789 12.1889Z" />
    </g>
  </svg>
)
